import { Flex, FormControl, FormLabel } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaSave, FaTrash } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { InputCmp } from '../../../../components/InputCmp'
import { ModalBase } from '../../../../components/ModalBase'
import { ModalDelete } from '../../../../components/ModalDelete'
import { iParticipanteFeedbackResponse } from '../../../../interfaces'

interface iModalProps {
  isOpen: boolean
  onClose: () => void
  onUpdate: (id: string, newName: string) => void
  onDelete: (id: string) => void
  grupos: iParticipanteFeedbackResponse[]
}
export const ModalGerenciarGrupos: React.FC<iModalProps> = ({ isOpen, onClose, onUpdate, onDelete, grupos }) => {
  const [Grupos, setGrupos] = useState<iParticipanteFeedbackResponse[]>([])
  const [GrupoId, setGrupoId] = useState<string>()
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)

  function UpdateGruposArray(index: number, Texto: string): void {
    const array = [...Grupos]
    array[index].nomeGrupo = Texto
    setGrupos(array)
  }

  useEffect(() => {
    if (grupos !== undefined) {
      setGrupos(grupos)
    }
  }, [grupos])

  return (
        <ModalBase
            Titulo="Gerenciando grupo de participantes"
            onClose={onClose}
            isOpen={isOpen}
            Width='60rem'
        >
          {GrupoId && <ModalDelete
            isOpen={ModalDeleteIsOpen}
            message='Tem certeza que deseja excluir este grupo?'
            onConfirm={() => onDelete(GrupoId)}
            onRequestClose={() => { setModalDeleteIsOpen(false); setGrupoId(undefined) }}
            center
          />}
            <Flex flexDirection={'column'} padding={'1rem'} borderBottom={'1px solid var(--c4)'}>
                <FormControl>
                    <FormLabel fontSize={'lg'} marginBottom={'.3rem'}>Grupos</FormLabel>
                    <Flex display={'grid'} gap={'1rem 1rem'}>
                        {
                           Grupos.filter(e => e.colaboradoresId.length === 0)?.map((e, i) => {
                             return (
                                    <Flex gap={'1rem'} key={i}>
                                      <InputCmp
                                          placeholder={`Grupo ${i !== 0 ? i : ''}`}
                                          borderColor={'var(--Gray4)'}
                                          value={e.nomeGrupo}
                                          OnChange={(e) => UpdateGruposArray(i, e)}
                                          onBlur={() => onUpdate(e.id, e.nomeGrupo ?? '')}
                                      />
                                      <ButtonCmp VarColor='Red' onClick={() => { setGrupoId(e.id); setModalDeleteIsOpen(true) }}><FaTrash/></ButtonCmp>
                                    </Flex>
                             )
                           })
                        }

                    </Flex>
                </FormControl>
            </Flex>
            <Flex justifyContent={'end'} padding={'1rem'} gap={'.75rem'}>
                <ButtonCmp
                  VarColor='c6'
                  onClick={() => onClose()}
                >Fechar</ButtonCmp>
                <ButtonCmp
                  VarColor='Green2'
                  leftIcon={<FaSave />}
                  onClick={() => onClose()}
                >Salvar</ButtonCmp>
            </Flex>
        </ModalBase>
  )
}
